export const MATERIEL = {
  title: 'Créer un matériel',
  titleOnglet: {
    info: 'Info',
  },
  titleNumerique: 'Créer un matériel numérique',
  titleModification: 'Modifier matériel {code}',
  titleModificationWithoutCode: 'Modifier matériel',
  titleNumeriqueModification: 'Modifier matériel numérique {code}',
  detail: 'Détail matériel {code}',
  detailWithoutCode: 'Détail du matériel',
  actions: {
    saveAndUpdateCommandeLine: 'Sauvegarder et modifier les lignes de commande',
  },
  informationModification: 'Modifier le libellé de la face et des lignes de commande ?',
  copyImageSurProduits: 'Recopier la nouvelle image sur les produits liés ?',
  modifierEtatMontage: 'Modifier l\'état de montage sur les faces liées ?',
  saveActions: 'Comportement de la sauvegarde',
  detailNumerique: 'Détail matériel numérique {code}',
  titleAccesRapide: 'Accès rapide',
  contrat: 'Baux',
  product: 'Produit',
  caracteristiques: 'Caractéristiques',
  visibilite: 'Visibilité',
  numeriqueDevice: {
    title: 'Ecran numérique',
    timeLoop: 'Temps d\'une boucle (en seconde)',
    spotNumber: 'Nombre de spot',
    timeSpot: 'Temps de spot (en seconde)',
    idPlayer: 'Id player',
  },
  typePapier: 'Matériel papier',
  typeNumerique: 'Matériel numérique',
  materiel: 'Informations générales',
  infoTechnique: 'Informations techniques',
  otTechniques: 'OT technique',
  code: 'Code',
  codeConsultation: 'Code :',
  typeMateriel: 'Type de matériel',
  typeMaterielConsultation: 'Type de matériel :',
  disposition: 'Disposition',
  dispositionConsultation: 'Disposition :',
  localisation: 'Localisation',
  localisationConsultation: 'Localisation :',
  venantDe: 'En venant de',
  venantDeConsultation: 'En venant de :',
  allantVersConsultation: 'En allant vers :',
  allantVers: 'En allant vers',
  visibleSurLaConsultation: 'Visible sur la :',
  visibleSurLa: 'Visible sur la',
  angleVision: 'Angle de vision',
  angleVisionConsultation: 'Angle de vision :',
  azimut: 'Azimut',
  azimutConsultation: 'Azimut :',
  visibleFeu: 'Visible d\'un feu',
  visibleFeuConsultation: 'Visible d\'un feu :',
  visibleIntersection: 'Visible d’une intersection',
  visibleIntersectionConsultation: 'Visible d’une intersection :',
  eclaire: 'Eclairé',
  eclaireConsultation: 'Eclairé :',
  axe: 'Axe',
  axeConsultation: 'Axe :',
  isolement: 'Isolement',
  isolementConsultation: 'Isolement :',
  ecartAxe: 'Ecart / axe',
  ecartAxeConsultation: 'Ecart / Axe :',
  ecartVoie: 'Ecart / Voie',
  ecartVoieConsultation: 'Ecart / Voie :',
  longueurApproche: 'Longueur d’approche',
  longueurApprocheConsultation: 'Longueur d’approche :',
  passerelle: 'Passerelle',
  typeEclairage: 'Type d\'éclairage',
  success: 'Création du matériel réalisée avec succès',
  modification: 'Modification du matériel réalisée avec succès',
  pj: 'Pièces jointes',
  droite: 'Droite',
  gauche: 'Gauche',
  longueur: 'Longueur (cm)',
  largeur: 'Hauteur (cm)',
  idplayer: 'Id player',
  formatAffiche: 'Format d\'affiche',
  commentaire: 'Commentaire',
  commentaireConsultation: 'Commentaire :',
  commentaireSuiteDemontage: 'Commentaire suite démontage',
  tags: 'Tags',
  tagInfo: 'Si le tag n\'existe pas il sera créé en validant l\'entrée.',
  format: {
    title: 'Format',
    format: 'Format',
    surfaceCommerciale: 'Surface commerciale m²',
    surfaceCommercialePerso: 'Surface commerciale m² personnalisée',
    error: {
      formatId: 'Format',
    },
  },
  tlpe: {
    title: 'Informations sur la TLPE',
    typeTaxation: 'Type de taxation',
    surfaceTlpe: 'Surface TLPE m² déclarée',
    surfaceTlpePerso: 'Surface TLPE m² personnalisée déclarée',
    actions: {
      searchEnCours: 'Recherche...',
      noResult: 'Aucun résultat',
      ajouterTaxe: 'Ajouter un type de taxe',
    },
    informationTarifs: {
      title: 'Montant de la TLPE',
      anne: 'Année',
      montantAnnuel: 'Montant annuel déclaré',
      montantHebdo: 'Montant hebdomadaire déclaré',
      montantAnnuelRefacture: 'Montant annuel refacturé',
      montantHebdoRefacture: 'Montant hebdomadaire refacturé',
      actions: {
        cancel: 'Retour',
      },
    },
  },
  collectivite: {
    title: 'Collectivité TLPE',
    declarableMairie: 'Déclarable en mairie',
    addCollectivite: 'Ajouter une collectivité TLPE',
    etatMontageTlpe: 'Etat montage TLPE',
    etatDemontagelpe: 'Etat démontage TLPE',
  },
  descriptionTlpe: {
    title: 'Description TLPE',
    dispositifPublicitaire: {
      libelle: 'Dispositif publicitaire (D)',
      libelleCourt: 'D',
    },
    enseigneScellee: {
      libelle: 'Enseigne scellée (ES)',
      libelleCourt: 'ES',
    },
    enseigneNonScellee: {
      libelle: 'Enseigne non scellée (ENS)',
      libelleCourt: 'ENS',
    },
    preenseigne: {
      libelle: 'Préenseigne (P)',
      libelleCourt: 'P',
    },
    dispositionPublicitaireDCM: {
      libelle: 'Disposition publicitaire dépendant de concessions municipales (DCM)',
      libelleCourt: 'DCM',
    },
    dispositifPublicitaireDMU: {
      libelle: 'Dispositif publicitaire apposé sur les éléments de mobilier urbain (DMU)',
      libelleCourt: 'DMU',
    },
  },
  etatFilDeLeau: {
    nonGere: 'Non géré',
    declarationEnAttente: 'Déclaration en attente',
    declarationFaite: 'Déclaration faite',
  },
  libelleForLogo: 'Matériel {code}',
  messageInformations: {
    touteLesFacesSontNonDeclarable: 'Toutes vos faces sont non déclarables, le matériel a été modifié pour être non déclarable',
    uneDesFacesEstDeclarable: 'Une des faces du matériel est déclarable, le matériel a été modifié pour être déclarable',
    materielNonDeclarable: 'Le matériel est non déclarable, toutes les faces de ce matériel ont été modifiées pour être non déclarables',
  },
  archive: 'Archivé',
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver ce matériel ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver ce matériel ?',
  },
  messages: {
    success: {
      archivage: 'Matériel archivé avec succès.',
      desarchivage: 'Matériel désarchivé avec succès.',
      supprimer: 'Matériel supprimé avec succès',
      dupliquer: 'Matériel dupliqué avec succès',
    },
  },
  supprimer: {
    titre: 'Etes-vous sûr de vouloir supprimer ce matériel ?',
    sousTitre: 'Cela va supprimer aussi les faces liées à ce matériel',
  },
  dupliquer: {
    message: 'Etes-vous sûr de vouloir dupliquer ce matériel ?',
  },
  infoArchivageDesarchivage: {
    archivage: 'Cela va archiver aussi les faces liées à ce matériel',
    desarchivage: 'Cela va désarchiver aussi les faces liées à ce matériel',
  },
  errors: {
    materielInNSell: 'Matériel {code} est vendu dans {qte} commande(s)',
    materielInNTlpe: 'Matériel {code} est utilisé dans {qte} déclaration(s) tlpe',
    materielInNOtTech: 'Matériel {code} est utilisé dans {qte} OT(s)',
    materielInNContrat: 'Matériel {code} est utilisé dans {qte} baux',
    materielUsedInLogisticRequest: 'Matériel {code} est utilisé dans {qte} demande(s) d\'intervention(s)',
  },
};

export const DETAIL_MATERIEL = {
  tlpe: {
    title: 'Informations sur la TLPE',
    typeTaxation: 'Type de taxation :',
    surfaceTlpe: 'Surface TLPE m² déclarée :',
    surfaceTlpePerso: 'Surface TLPE m² personnalisée déclarée :',
    m2: '{surface} m²',
  },
  collectivite: {
    title: 'Collectivité TLPE',
    declarableMairie: 'Déclarable en mairie :',
    collectiviteInput: 'Collectivité TLPE :',
    etatMontageTlpe: 'Etat montage TLPE :',
    etatDemontagelpe: 'Etat démontage TLPE :',
  },
  format: {
    title: 'Format',
    format: 'Format :',
    surfaceCommerciale: 'Surface commerciale m² :',
    surfaceCommercialePerso: 'Surface commerciale m² personnalisée :',
  },
  infoTech: {
    title: {
      info: 'Info',
    },
    typeEclairage: 'Type d\'éclairage : ',
    passerelle: 'Passerelle :',
    longueur: 'Longueur (cm) : ',
    largeur: 'Hauteur (cm) : ',
    formatAffiche: 'Format d\'affiche : ',
  },
  descriptionTlpe: 'Description TLPE :',
  steps: {
    caracteristiques: 'Caractéristiques',
    format: 'Format',
    tlpe: 'Information sur la TLPE',
    montage: 'Montage / démontage',
    collectivite: 'Collectivité TLPE',
    numerique: 'Ecran numérique',
    visibilite: 'Visibilité',
    axe: 'Axe',
    commentaire: 'Commentaire',
    pj: 'Pièces jointes',
  },
  warning: {
    archivedTypeTaxationTlpeSelectedAbove: 'Le type de taxation tlpe ci-dessus est actuellement archivé',
  },
};

export const LISTE_MATERIEL = {
  title: 'Liste des matériels',
  actions: {
    search: 'Rechercher',
    edit: 'Modifier',
    filtre: 'Filtre',
  },
  tab: {
    code: 'Code',
    disposition: 'Disposition',
    formatAffiche: 'Format d\'affiche',
    format: 'Format',
    typeMateriel: 'Type de matériel',
    typeDispositif: 'Type de dispositif',
    support: 'Support',
    etatMontage: 'Etat montage',
    adresse: 'Adresse',
    agence: 'Agence',
    archive: 'Archivé',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    code: 'Code(s)',
    format: 'Format(s)',
    formatAffiche: 'Format(s) d\'affiche',
    typeMateriel: 'Type(s) de matériel',
    typeDispositif: 'Type(s) de dispositif',
    typeSupport: 'Type(s) de support',
    etat: 'Etat(s)',
    adresse: 'Adresse',
    ville: 'Ville(s)',
    au: ' au ',
    agglomerations: 'Agglomération(s)',
    avecCoordonnees: 'Avec coordonées',
    departements: 'Département(s)',
    dateMontage: 'Date de montage',
    dateDemontage: 'Date de démontage',
    tags: 'Tag(s)',
    actif: 'Actif',
    eclaire: 'Eclairé',
    codePostal: 'Code(s) postal',
    idPlayer: 'Id player(s)',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    client: 'Client(s)',
    associeABail: 'Associé a un bail',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver ce matériel ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver ce matériel ?',
  },
  messages: {
    success: {
      archivage: 'Matériel archivé avec succès.',
      desarchivage: 'Matériel désarchivé avec succès.',
    },
    error: {
      materielEtatDiffDemonte: 'Le matériel ne peut-être archivé que si son état de montage est à "démonté"',
      materielFace: 'Le matériel ne peut-être archivé que si ses faces sont à l\'état "démonté"',
      desarchivageImpossible: 'Le matériel ne peut-être désarchivé que si son dispositif est désarchivé',
    },
  },
  infoArchivageDesarchivage: {
    archivage: 'Cela va archiver aussi les faces liées à ce matériel ?',
    desarchivage: 'Cela va désarchiver aussi les faces liées à ce matériel ?',
  },
};

export const LISTE_MATERIEL_TLPE = {
  title: 'Liste des matériels TLPE',
  actions: {
    search: 'Rechercher',
    edit: 'Modifier',
    filtre: 'Filtre',
    editMaterielTlpe: 'Mise à jour informations Tlpe',
  },
  tab: {
    title: 'Matériels',
    code: 'Code',
    disposition: 'Disp.',
    format: 'Format',
    typeMateriel: 'Type',
    etat: 'Etat',
    typeDispositif: 'Dispositif',
    support: 'Support',
    adresse: 'Adresse',
    ville: 'Ville',
    agence: 'Agence',
    dateMontage: 'Date Montage',
    dateDemontage: 'Date Démontage',
    surface: 'Surface (m²)',
    collectivite: 'Collectivité',
    typeTaxation: 'Type Taxation',
    etatMontageTlpe: 'Etat montage TLPE',
    etatDemontageTlpe: 'Etat démontage TLPE',
    declarable: 'Dec.',
    numerique: 'Num.',
    nbFacesMontees: 'Faces actives',
    eclairage: 'Ecl.',
    confrere: 'Confrère',
    descriptionTlpe: 'Desc.',
    archive: 'Archivé',
  },
  filtre: {
    code: 'Code(s)',
    format: 'Format(s)',
    typeMateriel: 'Type(s) de matériel',
    typeDispositif: 'Type(s) de dispositif',
    typeSupport: 'Type(s) de support',
    disposition: 'Disposition(s)',
    collectivite: 'Collectivité(s)',
    typeTaxation: 'Type de taxation',
    declarable: 'Déclarable',
    eclaire: 'Eclairé',
    numerique: 'Numérique',
    agence: 'Agence',
    etat: 'Etat(s)',
    adresse: 'Adresse',
    ville: 'Ville(s)',
    au: ' au ',
    agglomerations: 'Agglomération(s)',
    dateMontage: 'Date de montage',
    dateDemontage: 'Date de démontage',
    sansDateMontage: 'Sans date de montage',
    sansDateDemontage: 'Sans date de démontage',
    sansCollectivite: 'Sans collectivité',
    sansTaxation: 'Sans type de taxation',
    confrere: 'Confrère(s)',
    avec: 'Avec',
    sans: 'Sans',
    actif: 'Actif',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    descriptionsTlpe: 'Description(s) TLPE',
    etatsMontageTlpe: 'Etat(s) montage TLPE',
    etatsDemontageTlpe: 'Etat(s) démontage TLPE',
  },
  popup: {
    updateInfosTlpe: {
      title: 'Mise à jour des informations des matériels',
      etat: 'Etat du matériel',
      dateMontage: 'Date de montage',
      dateDemontage: 'Date de démontage',
      format: 'Format',
      surface: 'Surface Tlpe personnalisée',
      collectivite: 'Collectivité',
      taxation: 'Type de taxation',
      declarable: 'Déclarable',
      prisEnCompte: 'Pris en compte',
      faces: 'Faces impactées',
      eclaire: 'Eclairé',
      descriptionTlpe: 'Description TLPE',
      etatMontageTlpe: 'Etat montage TLPE',
      etatDemontageTlpe: 'Etat démontage TLPE',
    },
    listeFaces: {
      title: 'Faces du matériel {codeMateriel} {disposition}',
      code: 'Code',
      dateMontage: 'Date montage',
      dateDemontage: 'Date démontage',
      declarable: 'Dec.',
      etat: 'Etat',
      archivee: 'Archivée',
    },
  },
};
